import { render, staticRenderFns } from "./WhaleBeanSettingDialog.vue?vue&type=template&id=141b1280&scoped=true"
import script from "./WhaleBeanSettingDialog.vue?vue&type=script&lang=ts"
export * from "./WhaleBeanSettingDialog.vue?vue&type=script&lang=ts"
import style0 from "./WhaleBeanSettingDialog.vue?vue&type=style&index=0&id=141b1280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b1280",
  null
  
)

export default component.exports